import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iccd-form',
  styleUrls: ['./iccd-form.component.scss'],
  templateUrl: './iccd-form.component.html',
})
export class IccdFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
